import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { ChevronLeft, FileText, Shield, Cookie, Cpu, Server } from "lucide-react";
import { COMPANY, LAST_UPDATED } from "@/lib/legalData";

const sections = [
  { to: "/privacy", label: "Privacy Policy", icon: Shield },
  { to: "/cookie-policy", label: "Cookie Policy", icon: Cookie },
  { to: "/termini", label: "Termini d'uso", icon: FileText },
  { to: "/trasparenza-ai", label: "Trasparenza AI Act", icon: Cpu },
  { to: "/sub-processors", label: "Sub-Responsabili (Sub-processor)", icon: Server },
];

export default function LegalLayout({ title, children, slug }) {
  return (
    <div className="min-h-screen bg-[#F8FAFC]">
      <header className="bg-white border-b border-slate-200 sticky top-0 z-30">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 h-20 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3 text-slate-500 hover:text-[#2456C6]">
            <ChevronLeft className="w-5 h-5" />
            <Logo className="h-12" />
          </Link>
        </div>
      </header>

      <main className="max-w-6xl mx-auto px-4 sm:px-6 py-10">
        <div className="grid lg:grid-cols-[240px_1fr] gap-8">
          {/* Sidebar nav */}
          <aside className="lg:sticky lg:top-28 lg:self-start">
            <div className="text-xs uppercase tracking-[0.2em] text-slate-500 font-bold mb-3">Area Legale</div>
            <nav className="space-y-1">
              {sections.map((s) => (
                <Link key={s.to} to={s.to} data-testid={`legal-nav-${s.to.replace(/\//g, "-")}`}
                  className={`flex items-center gap-2 px-3 py-2 rounded-lg text-sm font-bold transition-colors ${
                    slug === s.to ? "bg-[#F77F2A] text-white" : "text-slate-600 hover:bg-slate-100"
                  }`}>
                  <s.icon className="w-4 h-4" />
                  {s.label}
                </Link>
              ))}
            </nav>
            <div className="mt-6 p-3 rounded-lg bg-white border border-slate-200 text-[11px] text-slate-500 leading-relaxed">
              <b className="text-[#1E293B] block mb-1">Per esercitare i tuoi diritti</b>
              Scrivi a:<br/>
              <a href={`mailto:${COMPANY.privacy_email}`} className="text-[#2456C6] font-bold">{COMPANY.privacy_email}</a>
              <br/>oppure PEC:<br/>
              <a href={`mailto:${COMPANY.pec}`} className="text-[#2456C6] font-bold break-all">{COMPANY.pec}</a>
            </div>
          </aside>

          {/* Content */}
          <article className="bg-white rounded-2xl border border-slate-200 p-6 sm:p-10">
            <h1 className="text-3xl sm:text-4xl font-black text-[#1E293B] mb-2">{title}</h1>
            <div className="text-xs text-slate-500 mb-8 flex items-center gap-2">
              <span>Ultimo aggiornamento: <b>{LAST_UPDATED}</b></span>
              <span className="text-slate-300">·</span>
              <span>{COMPANY.brand} è un marchio di {COMPANY.legal_name}</span>
            </div>
            <div className="prose prose-slate max-w-none legal-content">
              {children}
            </div>
          </article>
        </div>
      </main>
    </div>
  );
}
